<template>
  <div id="box4">
    <div class="box">
      <div class="box-title">如何获得小谷币？</div>
      <div class="aaa"></div>
      <div class="item" v-for="(item, index) in list" :key="index">
        <div class="index">0{{ index + 1 }}</div>
        <div class="txt">{{ item.txt }}</div>
        <div
          class="button"
          v-if="index !== 6 && index !== 8"
          @click="Go(index)"
        >
          去选课
        </div>
        <div class="button" v-if="index === 6" @click="jihuo">去激活</div>
        <div class="button" id="islog" v-if="index === 8"></div>
        <div class="button" id="nolog" v-if="index === 8" @click="Login">
          去登录
        </div>
      </div>
      <div class="box2-two">
        <div class="box2-two-title">注意事项</div>
        <div class="box2-two-txt">每兑换一次礼品，消耗相应数量的小谷币</div>
        <div class="box2-two-txt">活动期间不能更换手机号，如若更换则不能累计小谷币</div>
        <div class="box2-two-txt">小谷币仅限活动期间使用，活动结束后小谷币清零</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    Login() {
      this.$store.commit("Openpop", 4);
    },
    Go(e) {
      if (e == 7) {
        window.open("https://www.boxuegu.com/all/");
        this.$mai(2, null, `去选课(微课)`);
        return;
      }
      document.querySelector("#box5").scrollIntoView(true);
      var name = "";
      switch (e) {
        case 0:
          name = "SVIP在线就业班";
          break;
        case 1:
          name = "VIP在线就业班";
          break;
        case 2:
          name = "年度会员制在线就业班";
          break;
        case 3:
          name = "半年度会员制在线就业班";
          break;
        case 4:
          name = "季度会员制在线就业班";
          break;
        case 5:
          name = "月度会员制在线就业班";
          break;
      }
      this.$mai(2, null, `去选课(${name})`);
    },
    jihuo() {
      this.$mai(1, null, "去激活(在线就业班)");
    },
  },
  data() {
    return {
      flag: false,
      list: [
        {
          txt: "报SVIP在线就业班，可获得3000个小谷币",
        },
        {
          txt: "报名VIP在线就业班，可获得1500个小谷币",
        },
        {
          txt: "报年度会员制在线就业班，可获得800个小谷币",
        },
        {
          txt: "报半年度会员制在线就业班可获得500个小谷币",
        },
        {
          txt: "报季度会员制在线就业班，可获300个小谷币",
        },
        {
          txt: "报名月度会员制在线就业班，可获得100个小谷币",
        },
        {
          txt: "活动期间激活在线就业班课程，可获得100个小谷币",
        },
        {
          txt: "报微课（成单金额≥100元）可获得50个小谷币",
        },
        {
          txt: "PC/H5端活动页登录，可获得50个小谷币（每人限1次）",
        },
      ],
    };
  },
};
</script>

<style lang='scss' scoped>
.box {
  overflow: hidden;
  margin: 0 auto;
  width: 690px;
  background-color: #6b00d9;
  #islog {
    background-image: url("../assets/islog.png");
    border: none;
  }
  .aaa {
    height: 10px;
  }
  .item {
    display: flex;
    align-items: center;
    margin: 0 auto;
    margin-top: 20px;
    width: 650px;
    height: 108px;
    background-color: #9f7fff;
    border-radius: 10px;
    .index {
      margin-left: 30px;
      width: 56px;
      height: 56px;
      background-color: #bca6ff;
      border-radius: 50%;

      font-family: Impact;
      font-size: 32px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 56px;
      letter-spacing: 1px;
      color: #ffffff;
      text-align: center;
    }
    .txt {
      margin-left: 22px;
      max-width: 304px;
      font-family: SourceHanSansCN-Normal;
      font-size: 24px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 1px;
      color: #ffffff;
    }
    .button {
      margin-left: 30px;
      width: 180px;
      height: 66px;
      border-radius: 12px;
      background-image: url("../assets/btn.png");
      background-size: 100% 100%;
      font-family: SourceHanSansCN-Medium;
      font-size: 28px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 66px;
      letter-spacing: 1px;
      color: #5530fd;
      text-align: center;
      border: solid 2px #532bff;
    }
  }
  &-title {
    margin: 0 auto;
    margin-top: 30px;
    width: 476px;
    height: 72px;
    background-color: #45008b;
    border-radius: 10px;
    text-align: center;
    font-family: SourceHanSansCN-Bold;
    font-size: 32px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 72px;
    letter-spacing: 2px;
    color: #ffffff;
  }
  .box2-two {
    overflow: hidden;
    margin: 0 auto;
    margin-top: 30px;
    margin-bottom: 30px;
    width: 650px;
    height: 280px;
    background-color: #ffffff;
    border-radius: 10px;
    &-title {
      margin-top: 31px;
      padding-left: 41px;
      font-family: SourceHanSansCN-Bold;
      font-size: 30px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 3px;
      color: #f94b4d;
    }
    &-txt {
      margin-top: 25px;
      font-family: SourceHanSansCN-Normal;
      font-size: 24px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #2d2664;
      &::before {
        content: "";
        display: inline-block;
        width: 8px;
        height: 8px;
        background-color: #2d2664;
        margin-left: 38px;
        margin-right: 10px;
        position: relative;
        top: -5px;
      }
    }
  }
}
</style>